import React from 'react';
import { useField } from 'formik';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { cn } from '@/lib/utils';

interface FormNumberFieldProps extends React.InputHTMLAttributes<HTMLInputElement> {
    name: string;
    label?: string;
    helpText?: string;
    required?: boolean;
    validate?: (value: unknown) => string | undefined;
}

export const FormNumberField: React.FC<FormNumberFieldProps> = ({
    label,
    helpText,
    className,
    required,
    validate,
    ...props
}) => {
    const validateFn = (value: unknown) => {
        if (required && (value === undefined || value === null || value === ''))
            return 'Campo obrigatório';
        if (validate) return validate(value);
        return undefined;
    };

    const [field, meta] = useField({ ...props, validate: validateFn });

    return (
        <div className={cn('space-y-2', className)}>
            {label && (
                <div className="space-y-1">
                    <Label
                        htmlFor={props.id || props.name}
                        className={cn(meta.touched && meta.error && 'text-destructive')}
                    >
                        {label} {required ? '*' : ''}
                    </Label>
                    {helpText ? (
                        <p className="text-sm leading-relaxed text-muted-foreground">{helpText}</p>
                    ) : null}
                </div>
            )}
            <Input
                {...field}
                {...props}
                type="number"
                id={props.id || props.name}
                className={cn(
                    meta.touched &&
                        meta.error &&
                        'border-destructive focus-visible:ring-destructive',
                )}
            />
            {meta.touched && meta.error ? (
                <p className="text-[0.8rem] font-medium text-destructive">{meta.error}</p>
            ) : null}
        </div>
    );
};
